// ** Redux Imports
import { combineReducers } from "redux"

// ** Reducers Imports
import auth from "./auth"
import navbar from "./navbar"
import layout from "./layout"
import config from "./config"
import socket from "./socket"
import tadbirData from "./tadbirData"
import utils from "./utils"
import userData from "./userData"
import access from "./access"
import permissionsSCO from "./permissionsSCO"
import permissionsDomkom from "./permissionsDomkom"
import noroziFuqaro from "./noroziFuqaro"
import chatSidebar from "./chat"
import cameraIP from "./cameraIP"
import isBusy from "./alarm/isBusy"
import usersSettings from "../../views/pages/AccountSettings/Users/store/reducers"
import gps from "./map/gps"
import ytx from "./map/ytx"
import busPark from "./map/busPark"
import TokenAxios from "./map/TokenAxios"
import cadastre from "./cadastre"
import ptzDetection from "./map/ptzDetection"
import metallDetection from "./map/metallDetection"
import jinoyatchilar from "./map/jinoyatchilar"
import hydrants from "./map/hydrants"
import shos from "./map/shos"
import camera from "./map/camera"
import addCamera from "./map/addCamera"
import tadbirkor from "./map/tadbirkor"
import onList from "./map/onList"
import saylov from "./map/saylov"
import body_camera from "./map/body_camera"
import menu from "../reducers/menuItems"
import ntfs from "../../views/pages/Search/NTFACE/store/reducer"
import noturarlar from "./map/noturarlar"
import fuqarolar from "../../views/pages/Search/Citizen/store/reducer"
import kameralar from "./map/kameralar"
import reja from "./map/reja"
import kuzatuv from "./map/kuzatuv"
import xatlovFromMap from "./map/xatlovFromMap"
import IIBService from "./map/IIB"
import inspektorHistory from "./map/inspektorHistory"
import alarm from "../reducers/alarm/"
import videoDetectionReducer from "../../views/pages/Search/VideoDetection/store/reducer"
import tools from "../../views/pages/Layers/Map/store/reducers/toolReducer"
import mahalla from "../../views/pages/Layers/Map/store/reducers/mahallaReducer"
import xatlov from "../../views/pages/Layers/Map/store/reducers/xatlovReducer"
import operative from "./map/operative"
import metallRama from "./map/metallRama"
import opg from "./map/opg"
import operativeModal from "./map/operativeModal"
import opgModal from "./map/opgModal"
import cameraSideBar from "./map/cameraSideBar"
import cameraStats from "./map/cameraStats"
import cameraMenuInArea from "./map/camera_menu_in_area"
import children from "./map/children"
import addLayer from "./map/addLayer"
import globalInerval from "./map/globalSetTimer"
import mapModalHeight from "./map/mapModalHeight"
import carNumber from "./map/carNumberSearch"
import XatlovP from "./Xatlov/index"
import { setTurarNoturar, setTurarNoturarLine, setLine } from "../actions/Xatlov"
import AddRoad from "./map/AddRaod"
import followingCars from "./map/followingCars"

import mahallalar from "./map/mahallalar"
import { reactModal } from "./map/reactModal"
import mtp from "./map/mtp"
import nearestPoliceAlert from "./map/nearestPoliceAlert"

import scenarioReducer from "./scenarioReducer"
import robberyModalState from "../../views/pages/Layers/Map/routes/Robbery/store/reducer"

const appReducer = combineReducers({
  AddRoad,
  mapModalHeight,
  setLine,
  shos,
  setTurarNoturarLine,
  setTurarNoturar,
  mahallalar,
  carNumber,
  globalInerval,
  auth,
  navbar,
  cameraMenuInArea,
  xatlovFromMap,
  access,
  permissionsSCO,
  permissionsDomkom,
  chatSidebar,
  tadbirData,
  cameraIP,
  layout,
  config,
  addLayer,
  mahalla,
  socket,
  utils,
  isBusy,
  addCamera,
  cadastre,
  usersSettings,
  gps,
  ytx,
  body_camera,
  busPark,
  reactModal,
  jinoyatchilar,
  hydrants,
  camera,
  tadbirkor,
  ntfs,
  onList,
  saylov,
  mtp,
  children,
  menu,
  noturarlar,
  inspektorHistory,
  kameralar,
  reja,
  kuzatuv,
  IIBService,
  ptzDetection,
  metallDetection,
  fuqarolar,
  alarm,
  videoDetectionReducer,
  operative,
  metallRama,
  opg,
  operativeModal,
  opgModal,
  robberyModalState,
  cameraSideBar,
  cameraStats,
  nearestPoliceAlert,
  //
  tools,
  xatlov,
  scenarioReducer,
  TokenAxios,
  userData,
  XatlovP,
  noroziFuqaro,
  followingCars
})

const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === "LOGOUT") {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer
